import script from "./SavedToSpendBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavedToSpendBalance.vue?vue&type=script&setup=true&lang=ts"

import "./SavedToSpendBalance.vue?vue&type=style&index=0&id=a883e58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a883e58a"]])

export default __exports__